module.exports = __webpack_public_path__ + "static/media/ckn_usuarios_nuevo.40ca5a95.jpg";